import packageJson from "@/package.json";

export const getLocale = (page) => {
    const [_, locale] = page.split("/");

    return packageJson.i18n.locales.includes(locale) ? locale : packageJson.i18n.defaultLocale;
};